import $ from 'jquery'
import './index.styl'
import { isApp } from '../../utils/page';
import { getSystem } from '../../utils/site';
import { INTERFACE } from '../../utils/INTERFACE';
import Cookies from 'js-cookie'
import * as compareVersions from 'compare-versions'

const tpl=str=>`
	<div class="cd-toast">
		<div class="text">${str}</div>
	</div>
`

function checkVersion(){
	let current=Cookies.get("cv")
	return compareVersions(current, '4.1.0')>=0
}

export default function(str){
	if(getSystem()=='EJSHOP'&&isApp()&&checkVersion()){
		window.location.href=INTERFACE().toast(str)
		return
	}
	var content=$(tpl(str)).hide()
	$("body").append(content)
	content.fadeIn()
	setTimeout(()=>{
		content.fadeOut(()=>{
			content.remove()
		})
	},2000)
}